import { create } from "zustand";

const useNetworkStore = create((set) => ({
  chainId: 0,
  name: "",
  provider: null,
  siggner: null,
  web3: null,
  nexusAccount: null,

  setNetwork: ({ name: paramName, value: paramValue }) =>
    set((state) => ({ [paramName]: paramValue })),

  resetNetwork: () =>
    set(() => ({
      chainId: 0,
      name: "",
      provider: null,
      siggner: null,
      web3: null,
      nexusAccount: null,
    })),
}));

export default useNetworkStore;
